import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { CarrierServiceItem } from '../../services/admin.carrier.service';
import styles from '../../styles/components/EditCarrierServiceModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface ServiceCountryDataModalProps {
    show: boolean;
    onHide: () => void;
    service: CarrierServiceItem | null;
}

const ServiceCountryDataModal: React.FC<ServiceCountryDataModalProps> = ({ show, onHide, service }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className={styles.editServiceModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Tiempos de Entrega por País
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className={styles.serviceBrief} style={{ marginBottom: '16px' }}>
                    <p className={styles.carrierName}>{service?.carrier}</p>
                    <h4 className={styles.serviceName}>{service?.name}</h4>
                </div>

                <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '16px' }}>
                    Lista de países configurados con sus respectivos tiempos estimados de entrega para este servicio.
                </p>

                {service?.countryData && service.countryData.length > 0 ? (
                    <div style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                        <Table hover responsive style={{ margin: 0, fontSize: '14px', width: '100%' }}>
                            <thead style={{ backgroundColor: '#f8fafc' }}>
                                <tr>
                                    <th style={{ padding: '12px 16px', color: '#475569', fontWeight: '600', width: '40%', textAlign: 'center' }}>País</th>
                                    <th style={{ padding: '12px 16px', color: '#475569', fontWeight: '600', textAlign: 'center', width: '30%' }}>Días Mínimos</th>
                                    <th style={{ padding: '12px 16px', color: '#475569', fontWeight: '600', textAlign: 'center', width: '30%' }}>Días Máximos</th>
                                </tr>
                            </thead>
                            <tbody>
                                {service.countryData.map((row) => (
                                    <tr key={row.id}>
                                        <td style={{ padding: '12px 16px', verticalAlign: 'middle' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                <img
                                                    src={`https://flagcdn.com/w40/${row.isO2Country.toLowerCase()}.png`}
                                                    srcSet={`https://flagcdn.com/w80/${row.isO2Country.toLowerCase()}.png 2x`}
                                                    width="20"
                                                    height="14"
                                                    alt={row.isO2Country}
                                                    style={{ objectFit: 'contain', borderRadius: '2px' }}
                                                    loading="lazy"
                                                />
                                                <span style={{ fontWeight: '500', color: '#1e293b' }}>
                                                    {row.isO2Country.toUpperCase()}
                                                </span>
                                            </div>
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', color: '#475569', verticalAlign: 'middle', fontWeight: '600' }}>
                                            {row.minDays} d
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', color: '#475569', verticalAlign: 'middle', fontWeight: '600' }}>
                                            {row.maxDays} d
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '32px 16px',
                        color: '#64748b',
                        backgroundColor: '#f8fafc',
                        borderRadius: '12px',
                        border: '1px dashed #cbd5e1'
                    }}>
                        No hay tiempos configurados por país para este servicio.
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className={styles.modalFooter}>
                <Button 
                    variant="secondary" 
                    onClick={onHide} 
                    className={styles.secondaryBtn}
                >
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ServiceCountryDataModal;
